import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Juan', 'María', 'Carlos', 'Sofía', 'Diego', 'Lucía', 'Andrés', 'Paula'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'Salta'];
export function SocialProofNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showNotification = () => {
      setData({
        name: names[Math.floor(Math.random() * names.length)],
        city: cities[Math.floor(Math.random() * cities.length)]
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const interval = setInterval(showNotification, 15000);
    setTimeout(showNotification, 3000);
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-204">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 50
    }} className="fixed bottom-4 right-4 z-50 bg-green-900/90 backdrop-blur-md border border-green-700/30 p-4 rounded-xl shadow-2xl flex items-center gap-3" data-id="element-205">
          <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center text-white text-xs font-bold" data-id="element-206">
            ✓
          </div>
          <div data-id="element-207">
            <p className="text-xs text-white" data-id="element-208">
              <span className="font-bold" data-id="element-209">{data.name}</span> de {data.city}
            </p>
            <p className="text-[10px] text-green-300" data-id="element-210">
              Acaba de comprar el Mega Pack ⚡
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}